<template>
  <!--begin::Mixed Widget 1-->
  <div class="card card-custom bg-gray-100 card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 bg-danger py-6">
      <h3 class="card-title font-weight-bolder text-white">
        Detail Aktivitas Siswa {{ namaKelas }}
      </h3>
      <div class="card-toolbar">
        <b-button @click="reloadData">Reload</b-button>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body pt-3 pb-0">
      <!--begin::Table-->
      <div class="table-responsive">
        <table class="table table-borderless table-vertical-center">
          <thead>
            <tr>
              <th class="p-0" style="width: 50px"></th>
              <th class="p-0" style="min-width: 150px"></th>
              <th class="p-0" style="min-width: 100px"></th>
              <th class="p-0" style="min-width: 125px"></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in dataSiswa">
              <tr v-bind:key="i">
                <td class="pl-0">
                  {{ i + 1 }}
                </td>
                <td class="pl-0">
                  <a
                    href="#"
                    :class="{
                      'font-weight-bolder text-hover-primary mb-1 font-size-lg': true,
                      'text-danger': item.tunda && !item.pembatalTunda
                    }"
                  >
                    {{ item.nama }}
                  </a>
                  <div>
                    <span>NIS: {{ item.nis }} </span>
                    <span
                      class="text-danger"
                      v-if="item.tunda && !item.pembatalTunda"
                      >(Tertunda)
                    </span>
                    <span class="text-success" v-if="item.logins.length > 0"
                      >(Sudah Login)</span
                    >
                    <span
                      class="text-success"
                      v-if="item.downloadRapotLog.length > 0"
                      >(Sudah Download)</span
                    >
                    <span class="text-warning" v-if="item.logins.length == 0"
                      >(Belum Login)</span
                    >
                  </div>
                </td>
                <td class="text-right">
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                  >
                    {{ item.logins.length }}x
                  </span>
                  <span class="text-muted font-weight-bold">Login</span>
                </td>
                <td class="text-right">
                  <div>
                    <span class="text-muted font-weight-500">
                      {{ item.rapotInfoLog.length }}x
                    </span>
                    <span class="text-muted font-weight-bold">Lihat Info</span>
                  </div>
                  <div>
                    <span class="text-muted font-weight-500">
                      {{ item.downloadRapotLog.length }}x
                    </span>
                    <span class="text-muted font-weight-bold">Download</span>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!--end::Table-->
    </div>
    <!--end::Mixed Widget 1-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "widget-1",
  components: {},
  props: ["dataSiswa"],
  computed: {
    ...mapGetters(["layoutConfig"]),
    namaKelas() {
      return this.dataSiswa[0].kelas.label;
    }
  },
  mounted() {
    // reference; kt_mixed_widget_1_chart
  },
  methods: {
    reloadData() {
      window.location.reload();
    }
  }
};
</script>
